import api from "./api.ts";

export interface PartnerUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  status: string;
  role: string;
  createdAt: string;
  updatedAt: string;
}

export async function getPartnerUsers(): Promise<PartnerUser[]> {
  const response = await api.get<PartnerUser[]>("/partner/users");
  return response.data;
}

export interface CreatePartnerUserParams {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  organizationIds: string[]; // 新增 organizationIds 字段
}

export interface CreatePartnerUserResponse {
  message: string;
  invitationId: string;
}

export async function createPartnerUser(
  params: CreatePartnerUserParams
): Promise<CreatePartnerUserResponse> {
  const response = await api.post<CreatePartnerUserResponse>(
    "/partner/users",
    params
  );
  return response.data;
}

export interface DeletePartnerUserResponse {
  message: string;
  data: {
    id: string;
    email: string;
    deletedAt: string;
  };
}

export async function deletePartnerUser(
  userId: string
): Promise<DeletePartnerUserResponse> {
  const response = await api.delete<DeletePartnerUserResponse>(
    `/partner/users/${userId}`
  );
  return response.data;
}

export interface SendForgetPasswordEmailParams {
  partnerNumber: string;
  email: string;
}

export async function sendForgetPasswordEmail(
  params: SendForgetPasswordEmailParams
): Promise<{ message: string }> {
  const response = await api.post<{ message: string }>(
    "/partner/auth/send_forget_password_email",
    params
  );
  return response.data;
}

export interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  message?: string;
  error?: string;
}

export async function changePassword(
  params: ChangePasswordParams
): Promise<ChangePasswordResponse> {
  const response = await api.post<ChangePasswordResponse>(
    "/partner/auth/change-password",
    params
  );
  return response.data;
}

export interface ResetPasswordParams {
  partnerNumber: string;
  email: string;
  verifyCode: string;
  password: string;
  isEncrypted: boolean;
}

export interface ResetPasswordResponse {
  message?: string;
  error?: string;
}

export async function resetPassword(
  params: ResetPasswordParams
): Promise<ResetPasswordResponse> {
  const response = await api.post<ResetPasswordResponse>(
    "/auth/reset_password",
    params
  );
  return response.data;
}

export interface UpdatePartnerUserParams {
  firstName?: string;
  lastName?: string;
  role?: string;
  organizationIds?: string[]; // 新增 organizationIds 字段
}

export interface UpdatePartnerUserResponse {
  message: string;
  data: PartnerUser;
}

export async function updatePartnerUser(
  userId: string,
  params: UpdatePartnerUserParams
): Promise<UpdatePartnerUserResponse> {
  const response = await api.put<UpdatePartnerUserResponse>(
    `/partner/users/${userId}`,
    params
  );
  return response.data;
}
